import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { Grid, Skeleton, units } from '@hbf/dsl';
import { useMediaQuery } from 'ha/helpers/MediaQuery';
import { ImageGridSkeleton } from 'ha/components/ImageGrid/ImageGridSkeleton';

const useStyles = makeStyles()({
  margin: {
    margin: units.yx(1, 0),
  },
  marginBottom: {
    marginBottom: units.rem(1),
  },
});

const GalleryLayoutSkeleton: React.FC = () => {
  const { classes } = useStyles();
  const { md } = useMediaQuery();

  return (
    <React.Fragment>
      {md ? (
        <Grid container>
          <Grid container className={classes.margin}>
            <Grid item xs={12}>
              <Skeleton variant="rectangular" height="4rem" />
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <ImageGridSkeleton numPhotos={1} />
            </Grid>
          </Grid>
          <Grid container className={classes.margin}>
            <Grid item xs={12}>
              <Skeleton variant="rectangular" height="4rem" />
            </Grid>
          </Grid>
        </Grid>
      ) : (
        <Grid container>
          <Grid container className={classes.margin}>
            <Grid item xs={12}>
              <Skeleton variant="rectangular" height="2rem" />
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12}>
              <ImageGridSkeleton numPhotos={1} />
            </Grid>
          </Grid>
          <Grid container className={classes.margin}>
            <Grid item xs={12}>
              <Skeleton variant="rectangular" height="2rem" />
            </Grid>
          </Grid>
          <Grid container className={classes.marginBottom}>
            <Grid item xs={12}>
              <Skeleton variant="rectangular" height="2rem" />
            </Grid>
          </Grid>
        </Grid>
      )}
    </React.Fragment>
  );
};

export { GalleryLayoutSkeleton };
